import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/database';
import { getFunctions as getFns, httpsCallable } from "firebase/functions";

import { firebaseConfig } from 'src/config';

if (!firebase.apps.length) {
  console.log('Firebase Config', firebaseConfig);
  firebase.initializeApp(firebaseConfig);
}

// Firestore
export const getDb = () => {
  if (firebase.apps.length) {
    return firebase.app().firestore();
  }
  return null;
};

// Firestore Timestamp
export const getTimestampFromDate = (date) => {
  return firebase.firestore.Timestamp.fromDate(date);
};

// Storage
export const getStorage = () => {
  if (firebase.apps.length) {
    return firebase.app().storage();
  }
  return null;
};

// Realtime Database
export const getRealtimeDatabase = () => {
  if (firebase.apps.length) {
    return firebase
      .app()
      .database('https://myitarra-95fb4-default-rtdb.europe-west1.firebasedatabase.app/');
  }
  return null;
};

// Cloud Functions (always point to the region where you deployed)
export const getFunctions = () => {
  if (firebase.apps.length) {
    return getFns(firebase.app(), "us-central1");  // ✅ match your deployed region
  }
  return null;
};

// Helper to call a Cloud Function
export const callFunction = async (name, data = {}) => {
  const functions = getFunctions();
  const fn = httpsCallable(functions, name);
  return fn(data);
};

export default firebase;
